import React, { useCallback, useEffect, useState } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | null>(null);
  const closeModal = useCallback(() => setModalContent(null), []);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && modalContent) closeModal();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [modalContent, closeModal]);
  return <>
      <footer className="py-16 border-t border-white/5 text-center px-5 bg-dark" role="contentinfo" data-id="element-30">
        <div className="flex items-center justify-center gap-6 text-sm mb-6" data-id="element-31">
          <button onClick={() => setModalContent('privacy')} className="bg-transparent border-none text-white/50 underline cursor-pointer text-[11px] uppercase transition-colors hover:text-gold" data-id="element-32">
            Privacy Policy
          </button>
          <span className="text-white/20" aria-hidden="true" data-id="element-33">
            |
          </span>
          <button onClick={() => setModalContent('terms')} className="bg-transparent border-none text-white/50 underline cursor-pointer text-[11px] uppercase transition-colors hover:text-gold" data-id="element-34">
            Terms of Service
          </button>
        </div>
        <p className="text-[10px] text-white/40 mt-8 tracking-[1px] leading-relaxed max-w-2xl mx-auto uppercase" data-id="element-35">
          © 2026 THE 888 CODE. THIS SITE IS NOT PART OF FACEBOOK OR META INC.{' '}
          <br data-id="element-36" />
          ALL RIGHTS RESERVED. TOTAL LIQUIDITY REPROGRAMMING.
        </p>
      </footer>

      {/* Legal Modal */}
      {modalContent && <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" role="dialog" aria-modal="true" aria-label={modalContent === 'privacy' ? 'Privacy Policy' : 'Terms of Service'} onClick={e => {
      if (e.target === e.currentTarget) closeModal();
    }} data-id="element-37">
          <div className="bg-[#0f0f11] border border-gold/30 rounded-xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl" data-id="element-38">
            <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-39">
              <h3 className="text-xl font-serif font-bold text-gold uppercase tracking-wider" data-id="element-40">
                {modalContent === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
              </h3>
              <button onClick={closeModal} aria-label="Close" className="text-white/50 hover:text-white transition-colors p-1" data-id="element-41">
                <X size={24} data-id="element-42" />
              </button>
            </div>

            <div className="p-6 overflow-y-auto text-sm text-white/85 space-y-6 leading-relaxed" data-id="element-43">
              {modalContent === 'privacy' ? <>
                  <p data-id="element-44">
                    <strong data-id="element-45">1. Information Collection</strong>
                    <br data-id="element-46" />
                    We collect information when you register on our site, place
                    an order, or participate on the site. The information
                    collected includes your name, email address, and payment
                    details.
                  </p>

                  <p data-id="element-47">
                    <strong data-id="element-48">2. Use of Information</strong>
                    <br data-id="element-49" />
                    Any information we collect from you may be used to:
                    personalize your experience, improve our website, process
                    transactions, and send periodic emails.
                  </p>

                  <p data-id="element-50">
                    <strong data-id="element-51">3. E-commerce Privacy</strong>
                    <br data-id="element-52" />
                    We are the sole owners of the information collected on this
                    site. Your personal information will not be sold, exchanged,
                    transferred, or given to any other company for any reason,
                    without your consent, other than for the express purpose of
                    delivering the purchased product.
                  </p>

                  <p data-id="element-53">
                    <strong data-id="element-54">4. Meta Pixel and Tracking</strong>
                    <br data-id="element-55" />
                    We use the Meta (Facebook) Pixel and other tracking
                    technologies to understand how you interact with our website
                    and to optimize our advertising campaigns. This allows us to
                    show you relevant ads based on your interests.
                  </p>

                  <p data-id="element-56">
                    <strong data-id="element-57">5. Consent</strong>
                    <br data-id="element-58" />
                    By using our site, you consent to our privacy policy.
                  </p>
                </> : <>
                  <p data-id="element-59">
                    <strong data-id="element-60">1. Acceptance of Terms</strong>
                    <br data-id="element-61" />
                    By accessing and using this website and purchasing "The 888
                    Code", you agree to be bound by these Terms of Service and
                    all applicable laws and regulations.
                  </p>

                  <p data-id="element-62">
                    <strong data-id="element-63">2. Nature of the Product</strong>
                    <br data-id="element-64" />
                    "The 888 Code" is a digital product (audio and PDF manual).
                    Upon purchase, you will receive immediate access to download
                    or view the content. No physical product will be shipped.
                  </p>

                  <p data-id="element-65">
                    <strong data-id="element-66">3. Refund Policy</strong>
                    <br data-id="element-67" />
                    Due to the digital and immediately accessible nature of this
                    product, all sales are final. We do not offer refunds once
                    the product has been delivered digitally, unless required by
                    local law.
                  </p>

                  <p data-id="element-68">
                    <strong data-id="element-69">4. Intellectual Property</strong>
                    <br data-id="element-70" />
                    All content included in this product (texts, audios,
                    graphics, logos) is the exclusive property of The 888 Code.
                    Its reproduction, distribution, or resale without express
                    written authorization is strictly prohibited.
                  </p>

                  <p data-id="element-71">
                    <strong data-id="element-72">5. Disclaimer</strong>
                    <br data-id="element-73" />
                    The information and audios provided are for purely
                    educational and entertainment purposes. We do not guarantee
                    specific financial results. The testimonials shown are
                    individual experiences and do not constitute a guarantee of
                    similar results. We are not financial or medical advisors.
                  </p>
                </>}
            </div>

            <div className="p-6 border-t border-white/10 text-right" data-id="element-74">
              <button onClick={closeModal} className="px-6 py-2 bg-white/10 hover:bg-white/20 rounded text-sm font-bold transition-colors" data-id="element-75">
                Close
              </button>
            </div>
          </div>
        </div>}
    </>;
}